<template>
  <!-- bgClass[String(activityInfo.activityType) -->
  <div
    :class="['todays-deal-card', isSmall ? 'small-todays-deal-card':'', activateBgClass]"
  >
    <div class="left-price-info">
      <span v-if="activityInfo.activityType === 1">Flash Sales</span>
      <span v-if="activityInfo.activityType === 4">Limited Offer</span>
      <span v-if="activityInfo.activityType === 6">{{ activityInfo.bigDiscountSale?.title || 'Big Discount Sale' }}</span>
    </div>
    <div class="countdown">
      <span class="over-down" v-if="isOver">Event has ended.</span>
      <!-- <div class="countdown-content" v-else-if="day < 3"> -->
      <div :class="isSmall ? 'countdown-content small-countdown' : 'countdown-content'" v-else-if="day < 3">
        <p class="label">Closing in</p>
        <p class="value">
          <span class="cv">{{ countdown.hour }}</span>
          <span class="cc">&nbsp;:&nbsp;</span>
          <span class="cv">{{ countdown.minute }}</span>
          <span class="cc">&nbsp;:&nbsp;</span>
          <span class="cv">{{ countdown.second }}</span>
        </p>
      </div>
      <div v-else>{{ monthFormat }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useActivityCountdown } from '../useActivityCountdown'
export interface ICountdownOptions {
  queryTime: string,
  endTime: string,
  startTime: string
}
interface IProps {
  isSmall?: boolean
  activityInfo: ProductV3.SelectedSkuActivity,
  options: ICountdownOptions
}
const props = defineProps<IProps>()
const emits = defineEmits<{ (e: 'countdown:over', activity: ProductV3.SelectedSkuActivity): void }>()
const { $timeToHMS, $tz } = useNuxtApp()

const { day, isOver, countdown } = useActivityCountdown(props.options, props.activityInfo,
  activity => emits('countdown:over', activity), $timeToHMS)
const monthFormat = computed(() => $tz.timeToMonthRange(new Date(props.options.startTime), new Date(props.options.endTime)))
const activateBgClass = computed(() => day.value <= 3 ? (props.activityInfo.activityType === 1 ? 'flash-bg' : 'td-bg') : 'limited-bg')
</script>

<style lang="scss" scoped>
.todays-deal-card{
  display: flex;
  justify-content: space-between;
  color: #fff;
  align-items: center;
  font-weight: 600;
  height: 120px;
  overflow: hidden;
  padding: 0 30px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
// 秒杀背景
.flash-bg{
  background-image: url('https://image.kilimall.com/c/h5/imgs/ic_goods_detail_flashsales_bg.png');
}
// 其他活动 倒计时背景
.td-bg{
  background-image: url('https://image.kilimall.com/c/h5/imgs/ic_goods_details_td_bg.png');
}
// 其他活动 月份背景
.limited-bg{
  background-image: url('https://image.kilimall.com/c/h5/imgs/ic_goods_details_promotion_bg.png');
}

.left-price-info{ font-size: 32px; }
.countdown{ font-size: 24px; }
.countdown-content{
  margin-bottom: 20px;
  p{ line-height: 30px; }
  .label{ color: var(--default_color); }
  .value{margin-top: 8px;}
  .value .cv{
    background-color: var(--default_color);
    padding: 4px;
    font-size: 22px;
    border-radius: 3px;
  }
  .value .cc{ color: var(--default_color); }
}
.month-countdown{color: var(--default_color);}

.small-todays-deal-card{
  height: 80px;
}
.small-countdown{
  display: flex;
  align-items: center;
  margin-bottom: 0;
  height: 100%;
  p{ line-height: normal !important; }
  .label{ color: #fff; margin-right: 60px;}
}
</style>